import {buildTabs3and4} from '@components/product/global/tabs/Tab3And4Dynamic';
import {
  SingleProductFocusVerticalTabs
} from '@components/product/ProductPageTemplates/Components/SingleProductFocusWithAssets/SingleProductFocusProductTabs';
import {
  SingleProductFocusTabs1Description
} from '@components/product/ProductPageTemplates/Components/SingleProductFocusWithAssets/BuildTabs/SingleProductFocusTabs1Description';
import {
  SingleProductFocusTabs2Specifications
} from '@components/product/ProductPageTemplates/Components/SingleProductFocusWithAssets/BuildTabs/SingleProductFocusTabs2Specifications';

export const SingleProductFocusBuildProductTabs = ({
  product,
  variants,
  tabMedia,
  tabDescription,
  tabDescriptionTable,
  siteCollection,
  showDescription = true
}) => {
  const sku = product?.sku;
  const category = product?.category ?? siteCollection;
  const selectedVariant = product?.selectedVariant ?? product;
  const mediaTab = tabMedia;
  // console.log({category, product, selectedVariant});
  let metaData = {};

  const productMetafields = selectedVariant?.metafields;

  if (productMetafields || productMetafields?.length > 0) {
    metaData = productMetafields?.reduce((a, node) => {
      a[node.key] = node;
      return a;
    }, {});
  }

  let tabNames = [];
  let tabsData = [];
  if (showDescription) {
    metaData.description = tabDescription;
    metaData.descriptionTable = tabDescriptionTable;
    tabNames.push('Description');
    tabsData.push(
      <SingleProductFocusTabs1Description
        key={'description'}
        tabDescriptionTableValue={tabDescriptionTable}
        tabDescriptionBodyValue={tabDescription}
      />
    );
  }

  const specificationsValue = metaData?.tab_specifications?.value;
  if (specificationsValue) {
    tabNames.push('Specifications');
    tabsData.push(
      <SingleProductFocusTabs2Specifications key={`specifications`} value={specificationsValue} />
    );
  }

  // console.log({category, mediaTab});
  const {tabNames3and4, tabsData3and4} = buildTabs3and4(
    sku,
    metaData,
    category,
    mediaTab,
    product,
    variants
  );

  if (tabNames3and4 && tabNames3and4?.length > 0) {
    tabNames = [...tabNames, ...tabNames3and4];
    tabsData = [...tabsData, ...tabsData3and4];
  }

  const tabsDataSections = tabsData?.map((tab, index) => {
    return <div key={index}>{tab}</div>;
  });

  return (
    <SingleProductFocusVerticalTabs
      tabNames={tabNames}
      sections={tabsDataSections}
      showDescription={showDescription}
    />
  );
};
